import React from 'react'
import { Metadata } from 'next';
import cl from '@/utils/console/cl';
import BlogDetails from '@/components/Blog/BlogDetails';
import urls from '@/utils/urls/urls';

export const dynamic = 'force-dynamic'

export const metadata: Metadata = {
    title: 'Blog Details | TEX EXCELLENCE LIMITED',
    description: 'Blog Details | TEX EXCELLENCE LIMITED',
}

export default async function BlogDetailsPage ({ params = {}  }: { params: any }) {
    // console.log("params", params)
    const blog_Id = params?.blogId;
    // cl("blogId", blog_Id);
    const res = await fetch(urls?.blogDetail + blog_Id)
    const data = await res.json()
    const blog = data?.data;
    // console.log("blogOne", blog) 
    return (
        <>
            <BlogDetails blog={blog} />
        </>
    )

}


// export async function generateStaticParams() {
//     return [
//         {
//             blogId: '123'
//         },

//     ]
// }